import { ICardForm } from '@/interface';
import { AIGC_MUSIC_PROMPT_LENGTH } from '@/interface/aigc';

export const aigcMusicFormCard: ICardForm = {
  key: 'aigcMusic',
  title: 'AI 智能音乐',
  fieldsConfig: [
    {
      props: 'prompt',
      className: 'aigc-text-prompt',
      notShowLabel: true,
      render: 'textareaPrompt',
      rules: [],
      uiOptions: {
        autosize: { minRows: 10, maxRows: 10 },
        maxlength: AIGC_MUSIC_PROMPT_LENGTH,
        placeholder: '请输入音乐描述关键词，以逗号分割',
        label: '音乐描述',
        required: true,
        polish: false,
      },
    },
    {
      props: 'tagChoose',
      render: 'tagChoose',
    },
  ],
};
